import React, { Component } from "react"
import t from "prop-types"
// import ButtonMenu from './ButtonMenu';
import { Link } from "gatsby"
import LocaleSwitch from "./app/header/LocaleSwitch"
import ButtonMenu from "./app/header/ButtonMenu"
import Button from "./wwc/ui/Button/Button"

class Header extends Component {
  static propTypes = {
    data: t.shape({
      hideMobileNavOnScroll: t.bool,
      logo: t.shape({
        title: t.string,
        image: t.string,
        alt: t.string,
      }),
      right: t.arrayOf(
        t.shape({
          label: t.string,
          anchor: t.string,
          hideOnMobile: t.bool,
        })
      ),
    }),
  }

  constructor(props) {
    super(props)
    this.lastScrollPosition = 0
    const isBrowser = typeof window !== `undefined`
    if (isBrowser) {
      this.headerOffset = window.innerWidth <= 768 ? 25 : 50
    }
  }

  componentDidMount() {
    /* Feature detection: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Improving_scrolling_performance_with_passive_listeners */
    let passiveIfSupported = false
    try {
      window.addEventListener(
        "test",
        null,
        Object.defineProperty({}, "passive", {
          get: function() {
            passiveIfSupported = { passive: false }
            return null
          },
        })
      )
    } catch (err) {}

    window.addEventListener("orientationchange", this.onResize.bind(this))
    window.addEventListener(
      "scroll",
      this.onScroll.bind(this),
      passiveIfSupported
    )
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll.bind(this))
  }

  render() {
    const { data, pageContext, path } = this.props
    const keys = Object.keys(data)

    return (
      <header
        className="wwc-header header"
        ref={ref => {
          this.header = ref
        }}
      >
        <div className="header__content">
          <Link to={data.logo.url} className="header__logo" title="Home Page">
            <span className="fouc-visible fouc-logo-text">{data.logo.alt}</span>
            <svg width="145px" height="57px" viewBox="0 0 145 57" version="1.1">
              <path
                d="M73.023704,40 C63.6570129,37.7277569 54.6534748,28.777415 52.476771,19.7577578 C50.3709262,10.9503787 55.3067074,-0.413003046 65.982078,0.0115533458 C69.248241,0.154516212 71.6441653,1.85924009 73.023704,3.13724147 C74.4032426,1.85924009 76.7991669,0.154516212 80.0675442,0.0115533458 C90.667627,-0.413003046 95.6764817,10.9503787 93.4997778,19.7577578 C89.795174,35.2410694 73.6060774,39.8592032 73.4599305,39.9285186 L73.023704,40 Z M79.9944707,9.3171363 C78.0325586,9.3171363 75.9997874,9.67237736 73.9692305,13.0818251 L73.023704,15.7093093 L72.0073183,12.8695469 C70.3377001,9.81534022 67.7956289,9.3171363 66.0529372,9.3171363 C64.1640985,9.3171363 62.7137007,10.6666191 62.2066151,11.3056198 C61.3341621,12.4406583 60.8979356,13.7923072 60.8979356,15.3540683 C60.8979356,16.1338657 60.971009,16.9158293 61.1880151,17.6977928 C63.0768538,26.5051718 71.0617918,30.1268978 73.023704,30.9088614 C74.9125426,30.1268978 82.8974807,26.5051718 84.8593928,17.6977928 C85.0055398,16.9158293 85.1494724,16.1338657 85.1494724,15.3540683 C85.1494724,13.7923072 84.6423867,12.4406583 83.8430072,11.3056198 C83.2606337,10.5951377 81.8810951,9.17417343 79.9944707,9.3171363 L79.9944707,9.3171363 Z"
                className="heart"
                fill="#007941"
              ></path>
              <polygon
                id="Fill-3"
                fill="#76BC43"
                points="136.1064 1 129.916506 26.1906266 129.826893 26.1906266 123.376902 1 116.575013 1 109.687882 26.1906266 109.600455 26.1906266 103.889229 1 95 1 104.80285 40 113.482252 40 119.932243 17.3965309 120.019671 17.3965309 125.774611 40 134.493355 40 145 1"
              ></polygon>
              <polygon
                id="Fill-4"
                fill="#76BC43"
                points="41.1067885 1 34.9171657 26.1906266 34.8275561 26.1906266 28.3778467 1 21.5762556 1 14.6894261 26.1906266 14.602002 26.1906266 8.89102592 1 0 1 9.80679285 40 18.4814442 40 24.9333392 17.3965309 25.0207632 17.3965309 30.7754513 40 39.4938147 40 50 1"
              ></polygon>
              <polygon
                id="Fill-5"
                fill="#76BC43"
                points="22.7988413 47 21.1383972 52.9239456 21.1091085 52.9239456 19.0588993 47 17.0379788 47 14.9742517 52.7725282 14.944963 52.7725282 13.370132 47 11 47 13.9266173 56 15.7965883 56 17.9729643 49.7711454 18 49.7711454 20.1763759 56 22.1161893 56 25 47"
              ></polygon>
              <path
                d="M31.1195652,47 L27,56 L29.3173913,56 L30.1108696,54.0938004 L33.8108696,54.0938004 L34.6326087,56 L37,56 L32.8543478,47 L31.1195652,47 Z M31.9282609,49.6176538 L33.1,52.415764 L30.7695652,52.415764 L31.9282609,49.6176538 Z"
                id="Fill-6"
                fill="#76BC43"
              ></path>
              <polygon
                id="Fill-7"
                fill="#76BC43"
                points="44.5788732 47 42.4978873 50.3685181 40.5373239 47 38 47 41.4795775 52.1606361 41.4795775 56 43.5204225 56 43.5204225 52.1606361 47 47"
              ></polygon>
              <path
                d="M55,52 C55,51.2390351 55.1247357,50.5482456 55.372093,49.9298246 C55.6215645,49.3135965 55.9682875,48.7850877 56.4122622,48.3508772 C56.858351,47.9166667 57.3868922,47.5833333 57.9978858,47.3486842 C58.6067653,47.1162281 59.2748414,47 60,47 C60.7230444,47 61.3911205,47.1162281 62.0021142,47.3486842 C62.6109937,47.5833333 63.141649,47.9166667 63.5856237,48.3508772 C64.0295983,48.7850877 64.3763214,49.3135965 64.6257928,49.9298246 C64.8752643,50.5482456 65,51.2390351 65,52 C65,52.7609649 64.8752643,53.4517544 64.6257928,54.0701754 C64.3763214,54.6885965 64.0295983,55.2149123 63.5856237,55.6491228 C63.141649,56.0855263 62.6109937,56.4188596 62.0021142,56.6513158 C61.3911205,56.8837719 60.7230444,57 60,57 C59.2748414,57 58.6067653,56.8837719 57.9978858,56.6513158 C57.3868922,56.4188596 56.858351,56.0855263 56.4122622,55.6491228 C55.9682875,55.2149123 55.6215645,54.6885965 55.372093,54.0701754 C55.1247357,53.4517544 55,52.7609649 55,52 M57.1205074,52 C57.1205074,52.4473684 57.1860465,52.8574561 57.3234672,53.2302632 C57.4566596,53.6030702 57.653277,53.9232456 57.9048626,54.1973684 C58.1585624,54.4714912 58.4608879,54.6842105 58.8139535,54.8355263 C59.167019,54.9890351 59.5623679,55.0657895 60,55.0657895 C60.435518,55.0657895 60.8308668,54.9890351 61.1839323,54.8355263 C61.5369979,54.6842105 61.8393235,54.4714912 62.0930233,54.1973684 C62.346723,53.9232456 62.5412262,53.6030702 62.6744186,53.2302632 C62.8118393,52.8574561 62.8794926,52.4473684 62.8794926,52 C62.8794926,51.5614035 62.8118393,51.1535088 62.6744186,50.7785088 C62.5412262,50.4013158 62.346723,50.0767544 62.0930233,49.8026316 C61.8393235,49.5285088 61.5369979,49.3157895 61.1839323,49.1644737 C60.8308668,49.0109649 60.435518,48.9342105 60,48.9342105 C59.5623679,48.9342105 59.167019,49.0109649 58.8139535,49.1644737 C58.4608879,49.3157895 58.1585624,49.5285088 57.9048626,49.8026316 C57.653277,50.0767544 57.4566596,50.4013158 57.3234672,50.7785088 C57.1860465,51.1535088 57.1205074,51.5614035 57.1205074,52"
                id="Fill-8"
                fill="#76BC43"
              ></path>
              <polygon
                id="Fill-10"
                fill="#76BC43"
                points="69 47 69 56 70.9714286 56 70.9714286 52.4925098 74.6979592 52.4925098 74.6979592 50.6609818 70.9714286 50.6609818 70.9714286 48.8294538 75 48.8294538 75 47"
              ></polygon>
              <polygon
                id="Fill-11"
                fill="#76BC43"
                points="94.7969429 47 93.1367659 52.9239456 93.1097345 52.9239456 91.0576026 47 89.0370072 47 86.9736122 52.7725282 86.9443282 52.7725282 85.3697506 47 83 47 85.9261464 56 87.7958166 56 89.9718423 49.7711454 90.0011263 49.7711454 92.1748994 56 94.1144006 56 97 47"
              ></polygon>
              <g
                id="Group-16"
                transform="translate(99.000000, 47.000000)"
                fill="#76BC43"
              >
                <path
                  d="M0.623519139,4.8599697 C0.623519139,4.12390909 0.754643541,3.45572727 1.02141388,2.85754545 C1.28818421,2.26148485 1.65894976,1.75027273 2.13371053,1.33027273 C2.61073206,0.910272727 3.17592344,0.587848485 3.82702392,0.360878788 C4.48038517,0.136030303 5.19478708,0.0236060606 5.97022967,0.0236060606 C6.74341148,0.0236060606 7.4578134,0.136030303 8.11117464,0.360878788 C8.76227512,0.587848485 9.32746651,0.910272727 9.80448804,1.33027273 C10.2792488,1.75027273 10.6500144,2.26148485 10.9167847,2.85754545 C11.183555,3.45572727 11.3169402,4.12390909 11.3169402,4.8599697 C11.3169402,5.5960303 11.183555,6.26421212 10.9167847,6.86239394 C10.6500144,7.46057576 10.2792488,7.96966667 9.80448804,8.38966667 C9.32746651,8.81178788 8.76227512,9.13421212 8.11117464,9.35906061 C7.4578134,9.58390909 6.74341148,9.69633333 5.97022967,9.69633333 C5.19478708,9.69633333 4.48038517,9.58390909 3.82702392,9.35906061 C3.17592344,9.13421212 2.61073206,8.81178788 2.13371053,8.38966667 C1.65894976,7.96966667 1.28818421,7.46057576 1.02141388,6.86239394 C0.754643541,6.26421212 0.623519139,5.5960303 0.623519139,4.8599697 M2.89106699,4.8599697 C2.89106699,5.29269697 2.96115072,5.68936364 3.10810048,6.0499697 C3.25278947,6.41057576 3.4607799,6.72027273 3.729811,6.98542424 C4.00110287,7.25057576 4.32439234,7.45633333 4.70420096,7.60269697 C5.07948804,7.75118182 5.5022512,7.82542424 5.97022967,7.82542424 C6.43594737,7.82542424 6.85871053,7.75118182 7.23625837,7.60269697 C7.61380622,7.45633333 7.93709569,7.25057576 8.20838756,6.98542424 C8.47967943,6.72027273 8.68540909,6.41057576 8.83235885,6.0499697 C8.97704785,5.68936364 9.04713158,5.29269697 9.04713158,4.8599697 C9.04713158,4.43572727 8.97704785,4.04118182 8.83235885,3.67845455 C8.68540909,3.31360606 8.47967943,2.99966667 8.20838756,2.73451515 C7.93709569,2.46936364 7.61380622,2.26360606 7.23625837,2.11724242 C6.85871053,1.96875758 6.43594737,1.89451515 5.97022967,1.89451515 C5.5022512,1.89451515 5.07948804,1.96875758 4.70420096,2.11724242 C4.32439234,2.26360606 4.00110287,2.46936364 3.729811,2.73451515 C3.4607799,2.99966667 3.25278947,3.31360606 3.10810048,3.67845455 C2.96115072,4.04118182 2.89106699,4.43572727 2.89106699,4.8599697"
                  id="Fill-12"
                ></path>
                <path
                  d="M14.801006,0.257787879 L18.6352644,0.257787879 C19.1394151,0.257787879 19.6164366,0.302333333 20.0685897,0.395666667 C20.5230036,0.484757576 20.9186376,0.637484848 21.2600132,0.849606061 C21.599128,1.06172727 21.8704199,1.34809091 22.071628,1.70657576 C22.2705754,2.06718182 22.3723098,2.51475758 22.3723098,3.05354545 C22.3723098,3.70263636 22.1891878,4.25627273 21.8274653,4.71021212 C21.4612213,5.16627273 20.9299414,5.45475758 20.2313648,5.57566667 L22.7498577,9.46384848 L20.1318911,9.46384848 L18.0610299,5.78354545 L16.9826447,5.78354545 L16.9826447,9.46384848 L14.801006,9.46384848 L14.801006,0.257787879 Z M16.9826447,4.06748485 L18.2712811,4.06748485 C18.4679677,4.06748485 18.6736974,4.06112121 18.8929916,4.04839394 C19.1145467,4.03354545 19.3112333,3.99536364 19.4898337,3.93172727 C19.6661734,3.8659697 19.8131232,3.76415152 19.930683,3.62415152 C20.0459821,3.48627273 20.104762,3.29112121 20.104762,3.04081818 C20.104762,2.80536364 20.0527644,2.61869697 19.9487691,2.48081818 C19.8470347,2.34293939 19.7159103,2.23687879 19.5576567,2.16263636 C19.3994031,2.09051515 19.2185419,2.03960606 19.0128122,2.01415152 C18.8070825,1.98657576 18.6081352,1.97384848 18.4114486,1.97384848 L16.9826447,1.97384848 L16.9826447,4.06748485 Z"
                  id="Fill-14"
                ></path>
                <polygon
                  id="Fill-17"
                  points="31.7859803 0 27.9606226 3.77548241 27.9606226 0 25.7894737 0 25.7894737 9.09090909 27.9606226 9.09090909 27.9606226 4.77696998 31.9680332 9.09090909 35 9.09090909 30.2419023 4.22384714 34.626904 0"
                ></polygon>
              </g>
            </svg>
          </Link>

          {keys.map((item, index) => {
            if (item === "left" || item === "center" || item === "right") {
              return this.renderNav(item, data[item], index)
            } else {
              return console.warn(
                `The following key : "${item}" is not expected in Header.js`
              )
            }
          })}

          <ButtonMenu onClick={this.toggleMenu} />
          <Button href="https://wowhub.wonderful.net/" className="hub">
            {pageContext.locale === "en" ? "Visit WOW Hub" : "Visita WOW Hub"}
          </Button>
          <LocaleSwitch pagePath={path} pageLocale={pageContext.locale} />
        </div>
      </header>
    )
  }

  renderNav(key, data, index) {
    const className = `nav nav--${key}`
    // const { pagePath, pageLocale } = this.props;

    return (
      <nav className={className} key={`nav__item-${index}`}>
        <ul className="nav-container">
          {data.map((item, index) => {
            if (item.logo) {
              return this.renderLogo(item)
            } else if (item.icon) {
              return this.renderIcon(item)
            } else {
              return this.renderNavItem(item, index)
            }
          })}
        </ul>
      </nav>
    )
  }

  renderIcon() {
    // TODO : Importing icon should be more dynamic.
    return <li>{<ButtonMenu onClick={this.openMenu} />}</li>
  }

  renderLogo(_data) {
    const { label } = _data
    return (
      <li className={this.getClassName(_data, "header__logo")}>
        <a href={_data.url}>
          <h1 itemScope="" itemType="http://schema.org/Organization">
            {label}
          </h1>
        </a>
      </li>
    )
  }

  renderNavItem(_data, index) {
    const { label, url, anchor, external } = _data
    if (external) {
      return (
        <li
          className={this.getClassName(_data, `nav__item`)}
          key={`list-item-${index}`}
        >
          <a href={url} target="_blank" rel="noopener noreferrer">
            {label}
          </a>
        </li>
      )
    } else {
      let _className = ""
      if (typeof window !== "undefined") {
        _className =
          window.location.pathname.indexOf(_data.url) >= 0 ? "active" : ""
      }

      return (
        <li
          className={this.getClassName(_data, `nav__item`)}
          key={`list-item-${index}`}
        >
          <Link
            className={_className}
            to={url}
            title={label}
            onClick={e => this.onNavItemClick(e, anchor)}
            activeClassName="active"
          >
            {label}
          </Link>
        </li>
      )
    }
  }

  toggleMenu = () => {
    document.documentElement.classList.toggle("menu-active")
  }

  closeMenu = () => {
    document.documentElement.classList.remove("menu-active")
  }

  onNavItemClick = (e, anchor) => {
    this.closeMenu()
    var section = document.getElementById(anchor)
    if (section) {
      e.preventDefault()
      section.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  onResize = () => {
    document.documentElement.classList.remove("menu-active")
  }

  onScroll = () => {
    if (this.header !== null) {
      if (window.pageYOffset > this.headerOffset) {
        this.header.classList.add("header__main--scroll")
        // this.newScrollPosition = window.pageYOffset;

        // if (this.newScrollPosition < this.lastScrollPosition) {
        //   this.header.classList.remove('header__main--hidden');
        // } else {
        //   this.header.classList.add('header__main--hidden');
        // }

        // this.lastScrollPosition = this.newScrollPosition;
      } else {
        this.header.classList.remove("header__main--scroll")
      }
    }
  }

  getClassName(_data, _class) {
    const { hideOnDesktop, hideOnMobile, cta } = _data
    let className = _class
    if (hideOnDesktop) {
      className += ` header--hide-desktop`
    } else if (hideOnMobile) {
      className += ` header--hide-mobile`
    } else if (cta) {
      className += ` btn__cta`
    }

    return className
  }
}

export default Header
